import type React from "react"
import { Paper, Typography } from "@mui/material"
import PropertyInfoCard from "./PropertyInfoCard"
import ChatMessageList from "./ChatMessageList"
import ChatInput from "./ChatInput"
import type { ConversationDto, MessageDto } from "../../types/message";


interface ChatContainerProps {
  selectedConversation: ConversationDto | null
  messages: MessageDto[]
  userProfileId: number | undefined
  onSendMessage: (message: string) => Promise<void>
}

const ChatContainer: React.FC<ChatContainerProps> = ({
  selectedConversation,
  messages,
  userProfileId,
  onSendMessage,
}) => {
  if (!selectedConversation) {
    return (
      <Paper
        elevation={2}
        sx={{
          borderRadius: "12px",
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "calc(100vh - 180px)",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, color: "text.secondary" }}>
          Selecciona una conversación para ver los mensajes
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ textAlign: "center", maxWidth: "400px" }}>
          Haz clic en una conversación de la lista para ver sus mensajes y responder.
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: "12px",
        p: 3,
        mb: 2,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 300px)",
      }}
    >
      {/* Property info card */}
      {selectedConversation.propertyInfo && <PropertyInfoCard propertyInfo={selectedConversation.propertyInfo} />}

      {/* Messages */}
      <ChatMessageList messages={messages} userProfileId={userProfileId} />

      {/* Input de mensaje */}
      <ChatInput onSendMessage={onSendMessage} />
    </Paper>
  )
}

export default ChatContainer
